import React from "react"
import { useRecordContext, useTranslate } from "react-admin"
import { Avatar, Grid, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material"
import SendIcon from "@mui/icons-material/Send"
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber"

import useStatistics from "utils/statistics"
import { SectionTitle } from "utils/SectionTitle"

const StatisticListItem = (props: any) => {
	const {
		icon,
		name,
		count,
		color
	} = props
	const translate = useTranslate()

	return (
		<ListItem>
			<ListItemAvatar>
				{/* @ts-ignore */}
				<Avatar sx={(theme) => ({ backgroundColor: theme.palette[color]?.main })}>
					{icon}
				</Avatar>
			</ListItemAvatar>
			<ListItemText
				primary={count}
				primaryTypographyProps={{ fontWeight: "bold", fontSize: "1.5rem", lineHeight: 1 }}
				// @ts-ignore
				sx={(theme) => ({ color: theme.palette[color]?.main })}
				secondary={translate(`resources.partner_events.statistics.${name}`, count)}
			/>
		</ListItem>
	)
}

const PartnerEventStatistics = () => {
	const record = useRecordContext()
	const statistics = useStatistics({
		path: "partner-events",
		id: record.id as number
	})

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} sm={6}>
				<SectionTitle label="resources.partner_events.statistics.general_label"/>
				<List disablePadding>
					<StatisticListItem
						icon={<SendIcon/>}
						name="mail"
						count={statistics.getCountOf("mail")}
						color="primary"
					/>
				</List>
			</Grid>
			<Grid item xs={12} sm={6}>
				<SectionTitle label="resources.partner_events.statistics.tickets_label"/>
				<List disablePadding>
					<StatisticListItem
						icon={<ConfirmationNumberIcon/>}
						name="sent"
						count={statistics.getCountOf("sent")}
						color="success"
					/>
					<StatisticListItem
						icon={<ConfirmationNumberIcon/>}
						name="used"
						count={statistics.getCountOf("used")}
						color="warning"
					/>
				</List>
			</Grid>
		</Grid>
	)
}

export default PartnerEventStatistics
